import { useRef } from 'react';
import AddLabelButton from './AddLabelButton';
import AddLabelDropdown from './AddLabelDropdown';
import EditLabelModal from './EditLabelModal';

export default function AddLabels({ addLabelTestId }: { addLabelTestId?: string } = {}) {
  const anchorEl = useRef(null);

  return (
    <>
      <AddLabelButton ref={anchorEl} data-testid={addLabelTestId} />
      <AddLabelDropdown anchorEl={anchorEl} />
      <EditLabelModal />
    </>
  );
}
